/**
 * Criminal law hub — register with the global subcategory registry.
 */
import { CRIMINAL_LAW_SLUG, criminalLawDefaultData } from "./criminalLawData";
import { CriminalLawArticlesTab, CriminalLawMediaTab, CriminalLawOverviewTab } from "./CriminalLawDesign";

export const criminalLawModule = {
  slug: CRIMINAL_LAW_SLUG,
  getDefaultData: () => criminalLawDefaultData,
  Views: {
    overview: CriminalLawOverviewTab,
    articles: CriminalLawArticlesTab,
    media: CriminalLawMediaTab,
  },
};
